export default {
    name: "Edit",
    data() {
        return {
            form: {
                id: null,
                userName: null,
                userAccount: null,
                phone: null,
                email: null,
                location: null,
                version: null
            }
        }
    },
    mounted: function () {
    },
    computed: {
        rules() {
            const checkEmail = (rule, value, callback) => {
                const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
                setTimeout(() => {
                    if (!value || mailReg.test(value)) {
                        callback()
                    } else {
                        callback(new Error(this.$t('userManage.message.email')))
                    }
                }, 100)
            };
            return {
                userName: [
                    {required: true, message: this.$t('userManage.message.userName'), trigger: 'blur'},
                    {max: 50, message: this.$t('userManage.message.tooLong') + 50, trigger: 'blur'}
                ],
                userAccount: [
                    {required: true, message: this.$t('userManage.message.userAccount'), trigger: 'blur'},
                    {max: 100, message: this.$t('userManage.message.tooLong') + 100, trigger: 'blur'}
                ],
                email: [
                    {validator: checkEmail, trigger: 'blur'}
                ],
                location: [
                    {max: 100, message: this.$t('userManage.message.tooLong') + 100, trigger: 'blur'}
                ]
            }
        },
    },
    created() {
        this.conditionData = this.$routerUtil.getParam();
        const data = this.conditionData.data;
        this.form = Object.assign({}, this.form, data);
    },
    methods: {
        edit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const param = {... this.form};
                    delete param.password
                    this.$axios.put('/api/accounts/updateAccount', param).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.back();
                        }
                        this.$message({
                            message: this.$t(response.data.message),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }
            });
        },
        back() {
            this.$routerUtil.setParam(this.conditionData.searchForm);
            this.$router.back();
        }
    }
}
